/* eslint-disable no-restricted-globals */
import ConstConfig from "config";
import { SetStateAction, useEffect, useState } from "react";
import { Button, Checkbox, Icon, Input, Select, TextArea } from "semantic-ui-react";
import api from "../services/api";
import Config, { getSubType } from "./Config";
import crypto from "crypto";
import CheatToken from "./token";
import { BodyPart, MongenMorale, PlotType, Rarity } from "interfaces";
import { DatePicker, Enum } from "components";
import dayjs from "dayjs";
import dataServices from "services/data";
export default function Cheat() {
  const [wallet_address, setWallet] = useState("");
  const [customer_id, setCustomerId] = useState("");
  const [plot_race, setPlotRace] = useState(0);
  const [plot_rarity, setPlotRarity] = useState(0);
  const [mongen_race, setMongenRace] = useState(0);
  const [mongen_rarity, setMongenRarity] = useState(0);
  const [plot_type, setPlotType] = useState(0);
  const [sub_plot_type, setSubPlotType] = useState(0);
  const [amount, setAmount] = useState(0);
  const [amount1, setAmount1] = useState(0);
  const [amount2, setAmount2] = useState(0);
  const [amount3, setAmount3] = useState(0);
  const [stage_id, setStageId] = useState(1);
  const [transactionType, setTransactionType] = useState(0);
  const [skiptime, setSkiptime] = useState(0);
  const [plot_id_skiptime, setPlotIdSkiptime] = useState(0);
  const [troop_id, setTroopId] = useState(0);
  const [mongen_id, setMongenId] = useState(0);
  const [cv_mongen_id, setCVMongenId] = useState(0);
  const [quantity, setQuantity] = useState(0);
  const [process, setProcess] = useState(0);
  const [level, setLevel] = useState(0);
  const [adventureStar, setAdventureStar] = useState(0);
  const [adventureStarReward, setAdventureStarReward] = useState(0);
  const [time, setTime] = useState(0);
  const [whitelistAddress, setWhitelistAddress] = useState("");
  const [whitelistType, setWhitelistType] = useState(0);
  const [pool, setPool] = useState([]);
  const [pool_id, setPoolId] = useState(1);
  const [mongenInfo, setMongenInfo] = useState<any>();
  const [typeSkill, setTypeSkill] = useState("");
  const troops: any = [];
  const [inputData, setInputData] = useState("");
  const [outputData, setOutputData] = useState("");
  const [isCopied, setCopied] = useState(false);
  const [walletAddressOutBattle, setWalletAddressOutBattle] = useState("");
  const [customerIdOutBattle, setCustomerIdOutBattle] = useState("");
  const [typeOutBattle, setTypeOutBattle] = useState("");
  const [moraleType, setMoraleType] = useState("");
  const [curseLevel, setCurseLevel] = useState(null);
  const [curseCode, setCurseCode] = useState(null);
  const [dateTo, setDateTo] = useState(null);
  const [moraleValue, setMoraleValue] = useState(null);
  const [battleCustomerId, setBattleCustomerId] = useState(null);
  const [battlefrontCustomerDate, setBattlefrontCustomerDate] = useState<any>();
  const IV_SIZE = 16;
  const position: number[] = [0.15, 0.21, 0.35, 0.63, 0.87, 0.92];
  const reverse: number[] = [...position].reverse();
  const [mark, setMark] = useState(0);
  const [mstrDaoRevenue, setMstrDaoRevenue] = useState(0);
  const [magDaoRevenue, setMagDaoRevenue] = useState(0);

  const [runeAmount, setRuneAmount] = useState(0);
  const [runeRarity, setRuneRarity] = useState(0);
  const [runeCode, setRuneCode] = useState(null);

  const [dna, setDna] = useState(null);
  const [troopList, setTroopList] = useState(null);
  const [customerId, setcustomerId] = useState(null);
  const [customerId1, setcustomerId1] = useState(null);
  const [customerId2, setcustomerId2] = useState(null);

  function getTime(): string {
    return (dayjs().add(-7, 'hour').diff(dayjs().startOf("year"), "minute") + "").padStart(6, "0");
  }

  function extractTime(text: string) {
    let time = "";
    let tmp = text;
    position.forEach((p: number) => {
      let textLength = tmp.length - 1;
      let index = Math.floor(textLength * p);
      time += tmp[index];
      tmp = [tmp.slice(0, index), tmp.slice(index + 1)].join("");
    });
    return { time: Number(time), text: tmp };
  }

  function mergeTime(text: string) {
    let tmp = text;
    //số phút tính từ đầu năm ===> ex: 000232
    let time = getTime();
    console.log("merge time ", time);
    reverse.forEach((p: number, pIndex: number) => {
      let textLength = tmp.length;
      let index = Math.floor(textLength * p);
      tmp = [
        tmp.slice(0, index),
        time[time.length - pIndex - 1],
        tmp.slice(index),
      ].join("");
    });
    return tmp;
  }

  const encrypt = (plainText: any, keyString: any) => {
    const iv = crypto.randomBytes(IV_SIZE);
    const cipher = crypto.createCipheriv("aes-256-cbc", keyString, iv);
    let cipherText = cipher.update(Buffer.from(plainText, "utf8"));
    cipherText = Buffer.concat([cipherText, cipher.final()]);
    const combinedData = Buffer.concat([iv, cipherText]);
    const combinedString = combinedData.toString("base64");
    return combinedString;
  };

  const decrypt = (combinedString: any, keyString: any) => {
    const combinedData = Buffer.from(combinedString, "base64");
    const iv = Buffer.alloc(IV_SIZE);
    const cipherText = Buffer.alloc(combinedData.length - iv.length);
    combinedData.copy(iv, 0, 0, iv.length);
    combinedData.copy(cipherText, 0, iv.length);
    const decipher = crypto.createDecipheriv("aes-256-cbc", keyString, iv);
    //@ts-ignore
    let plainText = decipher.update(cipherText, "utf8");
    //@ts-ignore
    plainText += decipher.final("utf8");
    return plainText;
  };

  const newEncryptInput = () => {
    let encrypted = encrypt(inputData, ConstConfig.EncruptedKey);
    setOutputData(mergeTime(encrypted));
  }

  const newDecryptInput = () => {
    let { time, text } = extractTime(inputData);
    let decrypted = decrypt(text, ConstConfig.EncruptedKey);
    setOutputData(decrypted);
  };


  const encryptInput = () => {
    let encrypted = encrypt(inputData, ConstConfig.EncruptedKey);
    setOutputData(encrypted);
  };

  const decryptInput = () => {
    let decrypted = decrypt(inputData, ConstConfig.EncruptedKey);
    setOutputData(decrypted);
  };

  useEffect(() => {
    api.getPool().then((data: SetStateAction<any[]>) => setPool(data));
  }, []);

  async function hackCreatePlot() {
    api
      .hackCreatePlot(wallet_address, plot_race, plot_rarity, plot_type, amount, sub_plot_type, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackAdventureStar() {
    api
      .cheatAdventureStar(wallet_address, adventureStar, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackAdventureStarReward() {
    api
      .cheatAdventureStarReward(wallet_address, adventureStarReward, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackAdventureStage() {
    api
      .hackAdventureStage(wallet_address, stage_id, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackTutorialProcess() {
    api
      .hackTutorialProcess(wallet_address, process, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function deleteName() {
    api
      .deleteName(wallet_address, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function outBattle() {
    if (typeOutBattle == null) return;
    api
      .outBattle({
        wallet_address: walletAddressOutBattle,
        customer_id: customerIdOutBattle,
        type: typeOutBattle,
      })
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackCreateEgg() {
    api
      .hackCreateEgg(wallet_address, mongen_race, mongen_rarity, amount1, mark, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackPlusPoint() {
    api
      .hackPlusPoint(wallet_address, amount2, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackOpenPlusQuest() {
    api
      .hackOpenPlusQuest(wallet_address, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function hackSkiptime() {
    api
      .hackSkiptime(wallet_address, plot_id_skiptime, skiptime, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackRecalculateStake() {
    const isCf = confirm(
      "Bạn có chắc không? Chắc thật không? Hàm này ảnh hưởng toàn hệ thống đó"
    );
    if (isCf) {
      api
        .recalculateStake()
        .then(() => {
          alert("success");
        })
        .catch((err: any) => {
          alert("failed");
        });
    }
  }

  async function skipFusionWait() {
    api
      .skipFusionWait(wallet_address, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function resetFusionMongenLimit() {
    const isCf = confirm(
      "Bạn có chắc không? Chắc thật không? Hàm này ảnh hưởng toàn hệ thống đó"
    );
    if (isCf) {
      api
        .resetFusionLimit()
        .then(() => {
          alert("success");
        })
        .catch((err: any) => {
          alert("failed");
        });
    }

  }

  async function hackCustomerTransaction() {
    api
      .hackCustomerTransaction(wallet_address, amount3, transactionType, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackRune() {
    api
      .hackRune(wallet_address, runeCode, runeRarity, runeAmount, customer_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackDeleteCustomer() {
    const isCf = confirm(
      "Bạn có chắc không? Chắc thật không? Hàm này sẽ xóa luôn account đó"
    );
    if (isCf)
      api
        .hackDeleteCustomer(wallet_address, customer_id)
        .then(() => {
          alert("success");
        })
        .catch((err: any) => {
          alert("failed");
        });
  }

  async function hackClaimScholarReward() {
    const isCf = confirm(
      "Bạn có chắc không? Chắc thật không? Hàm này sẽ ảnh hưởng cả hệ thống luôn đó"
    );
    if (isCf)
      api
        .hackClaimScholarReward()
        .then(() => {
          alert("success");
        })
        .catch((err: any) => {
          alert("failed");
        });
  }

  async function hackCreateTroops() {
    api
      .hackCreateTroops(troop_id, mongen_id, quantity)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function convertMongenToEgg() {
    api
      .convertMongenToEgg(cv_mongen_id)
      .then(() => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackClaimLevelReward() {
    api
      .cheatClaimLevelReward(wallet_address, level, customer_id)
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackTimeRequest() {
    // eslint-disable-next-line no-restricted-globals
    const isCf = confirm(
      "Bạn có chắc không? Chắc thật không? Hàm này ảnh hưởng toàn hệ thống đó"
    );
    if (isCf) {
      api
        .cheatSetQuestTime(wallet_address, time, customer_id)
        .then((data: any) => {
          alert("success");
        })
        .catch((err: any) => {
          alert("failed");
        });
    }
  }
  async function hackResetSharing() {
    api
      .cheatResetSharing(wallet_address, customer_id)
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackTimeFaucet() {
    const isCf = confirm(
      "Bạn có chắc không? Chắc thật không? Hàm này ảnh hưởng toàn hệ thống đó"
    );
    if (isCf)
      api
        .cheatSetFaucetTime(time)
        .then((data: any) => {
          alert("success");
        })
        .catch((err: any) => {
          alert("failed");
        });
  }
  function addWhiteList() {
    api
      .addWhitelist(whitelistType, whitelistAddress)
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  function hackCreateBox() {
    api
      .cheatCreateBox(wallet_address, pool_id, customer_id)
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackUpdateTroopMongen() {
    api
      .updateTroopMongen(mongen_id, mongenInfo.U)
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function cheatClaimBattlefrontSeasonReward() {
    api
      .cheatClaimBattlefrontSeasonReward()
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        console.log({ err })
        alert("failed");
      });
  }

  async function cheatClaimArenaSeasonReward() {
    api
      .cheatClaimArenaSeasonReward()
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        console.log({ err })
        alert("failed");
      });
  }

  async function hackUpdateMoraleMongen() {
    api
      .updateMoraleValue(mongen_id, moraleType, moraleValue)
      .then(async (data: any) => {
        await api
          .getMongenInfo(mongen_id)
          .then((res: { mongenInfo: (prevState: undefined) => undefined }) => {
            setMongenInfo(res.mongenInfo);
          })
          .catch((err: any) => { });
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }
  async function randomMorale() {
    api
      .randomMorale(mongen_id)
      .then(async (data: any) => {
        await api
          .getMongenInfo(mongen_id)
          .then((res: { mongenInfo: (prevState: undefined) => undefined }) => {
            setMongenInfo(res.mongenInfo);
          })
          .catch((err: any) => { });
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackUpdateSkillMongen() {
    if (!typeSkill) return;
    let skill_list = [];
    if (typeSkill === "basic") skill_list = mongenInfo.R;
    if (typeSkill === "ultimate") skill_list = mongenInfo.S;
    skill_list = skill_list.map((skill: string) => parseInt(skill));
    api
      .updateSkillMongen(mongen_id, skill_list, typeSkill)
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackgenerateInvest() {
    api
      .hackgenerateInvest()
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackUpdateCurse() {
    api
      .hackUpdateCurse({
        curseCode,
        curseLevel,
        wallet_address,
        customer_id
      })
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function hackDateBattlefront() {
    console.log(battlefrontCustomerDate);
    api
      .hackDateBattlefront({
        customer_id: battleCustomerId,
        date: battlefrontCustomerDate,
      })
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function cheatDaoRevenue() {
    api.hackDaoRevenue({
      mstr: mstrDaoRevenue,
      mag: magDaoRevenue,
    })
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function cheatCreateMongenByDna() {
    api.hackCreateMongenByDna(
      customerId,
      dna,
      troopList,
      amount
    )
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function cheatMatchBattlefront() {
    api.hackMatchBattlefront(
      customerId1,
      customerId2,
    )
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function cheatGetDaoRevenue() {
    api.hackGetDaoRevenue()
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  async function cheatCalculateStakeDao() {
    api.hackCalculateStakeDao()
      .then((data: any) => {
        alert("success");
      })
      .catch((err: any) => {
        alert("failed");
      });
  }

  return (
    <div className="w-100">
      <div className="w-full text-3xl text-center">Holy cheat</div>
      <CheatToken />
      <div className="card w-full flex gap-2 mt-4">
        <div className="card-body">
          <Input
            label="Wallet address"
            className="form-control"
            type="text"
            onChange={(evt: any) => {
              setWallet(evt.target.value);
            }}
          />
        </div>
        <div className="self-center">OR</div>
        <div className="card-body">
          <Input
            label="Customer ID"
            className="form-control"
            type="text"
            onChange={(evt: any) => {
              setCustomerId(evt.target.value);
            }}
          />
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Add whitelist</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4 flex gap-4">
              <Input
                label="Wallet address/Email"
                className="form-control"
                onChange={(evt: any) => {
                  setWhitelistAddress(evt.target.value);
                }}
              />
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setWhitelistType(Number(data.value));
                }}
                options={[
                  {
                    text: "Metamask",
                    value: 0,
                  },
                  {
                    text: "Terra",
                    value: 1,
                  },
                  {
                    text: "Email",
                    value: 2,
                  },
                ]}
              ></Select>
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={addWhiteList}
              >
                Add
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack Revenue Dao</div>
        <div className="d-flex w-full gap-4 flex">
          <Input
            label="MSTR"
            className="form-control"
            type="text"
            onChange={(evt: any) => {
              setMstrDaoRevenue(evt.target.value);
            }}
          />
          <Input
            label="Unlock MAG"
            className="form-control"
            type="text"
            onChange={(evt: any) => {
              setMagDaoRevenue(evt.target.value);
            }}
          />
          <Button
            color="green"
            className="ui green button btn btn-primary btn-lg"
            onClick={cheatDaoRevenue}
          >
            Hack
          </Button>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack Create Mongen</div>
        <div className="d-flex w-full gap-4 flex">
          <div className="w-80">
            <Input
              label="Customer ID 1"
              className="w-80"
              value={customerId || ""}
              placeholder="Customer ID"
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                setcustomerId(evt.target.value);
              }}
            />
          </div>
          <div className="w-80">
            <Input
              label="DNA"
              className="w-80"
              value={dna || ""}
              placeholder="DNA"
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                setDna(evt.target.value);
              }}
            />
          </div>
          <div className="w-80">
            <Input
              label="Troop List"
              className="w-80"
              value={troopList || ""}
              placeholder="Troop List"
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                setTroopList(evt.target.value);
              }}
            />
          </div>
          <div className="w-80">
            <Input
              label="amount"
              className="w-80 ml-4"
              type="text"
              onChange={(evt: any) => {
                setAmount(evt.target.value);
              }}
            />
          </div>
          <div className="w-10 ml-4">
            <Button
              icon="edit"
              color="blue"
              onClick={() => {
                window.open('/#/dna-editor', '_blank')
              }}
            />
          </div>
          <Button
            color="green"
            className="ui green button btn btn-primary btn-lg"
            onClick={cheatCreateMongenByDna}
          >
            Hack
          </Button>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack Match Battlefront</div>
        <div className="d-flex w-full gap-4 flex">
          <div className="w-80">
            <Input
              label="Customer ID 1"
              className="w-80"
              value={customerId1 || ""}
              placeholder="Customer ID"
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                setcustomerId1(evt.target.value);
              }}
            />
          </div>
          <div className="w-80">
            <Input
              label="Customer ID 2"
              className="w-80"
              value={customerId2 || ""}
              placeholder="Customer ID"
              onChange={(evt: React.ChangeEvent<HTMLInputElement>) => {
                setcustomerId2(evt.target.value);
              }}
            />
          </div>
          <Button
            color="green"
            className="ui green !ml-16 button btn btn-primary btn-lg"
            onClick={cheatMatchBattlefront}
          >
            Hack
          </Button>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack Get Revenue Dao From Analytics</div>
        <div className="d-flex w-full gap-4 flex">
          <Button
            color="green"
            className="ui green button btn btn-primary btn-lg"
            onClick={cheatGetDaoRevenue}
          >
            Hack
          </Button>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack Calculate DAO</div>
        <div className="d-flex w-full gap-4 flex">
          <Button
            color="green"
            className="ui green button btn btn-primary btn-lg"
            onClick={cheatCalculateStakeDao}
          >
            Hack
          </Button>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack reset sharing</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <div className="mt-3">
                <Button color="green" onClick={hackResetSharing}>
                  Reset
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack generate invests</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <div className="mt-3">
                <Button color="green" onClick={hackgenerateInvest}>
                  Generate
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack Claim End Battlefront Season</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <div className="mt-3">
                <Button color="green" onClick={cheatClaimBattlefrontSeasonReward}>
                  Hack
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack Claim End Arena Season</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <div className="mt-3">
                <Button color="green" onClick={cheatClaimArenaSeasonReward}>
                  Hack
                </Button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack time request</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <Input
                label="Time (after ? seconds)"
                className="form-control"
                type="number"
                onChange={(evt: any) => {
                  setTime(evt.target.value);
                }}
              />
              <Button
                color="red"
                className="btn btn-primary btn-lg"
                onClick={hackTimeRequest}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack time faucet</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <Input
                label="Time (after ? seconds)"
                className="form-control"
                type="number"
                onChange={(evt: any) => {
                  setTime(evt.target.value);
                }}
              />
              <Button
                color="red"
                className="btn btn-primary btn-lg"
                onClick={hackTimeFaucet}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack claim level reward</div>
        <div className="d-flex w-full">
          <div className="flex gap-4">
            <Input
              label="Level want to claim"
              className="form-control"
              type="text"
              onChange={(evt: any) => {
                setLevel(evt.target.value);
              }}
            />
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackClaimLevelReward}
            >
              Hack
            </Button>
          </div>
        </div>
      </div>
      <div className="card-body">
        <div className="card-title">Hack stage adventure</div>
        <div className="d-flex w-full">
          <div className="flex gap-4">
            <Input
              label="Stage ID you want to reach"
              className="form-control"
              type="text"
              onChange={(evt: any) => {
                setStageId(evt.target.value);
              }}
            />
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackAdventureStage}
            >
              Hack
            </Button>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack set adventure star</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <Input
                label="Star"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  setAdventureStar(evt.target.value);
                }}
              />
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackAdventureStar}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack set adventure star reward</div>
        <div className="d-flex w-full">
          <div className="row">
            <div className="flex gap-4">
              <Input
                label="Adventure star reward"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  setAdventureStarReward(evt.target.value);
                }}
              />
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackAdventureStarReward}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack stake</div>
        <div className="d-flex w-full">
          <Button
            color="yellow"
            className="btn btn-outline-primary btn-lg"
            onClick={hackRecalculateStake}
          >
            Skip section
          </Button>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack skip fusion waiting time</div>
        <div className="d-flex w-full">
          <Button
            color="yellow"
            className="btn btn-outline-primary btn-lg"
            onClick={skipFusionWait}
          >
            Skip fusion waiting time
          </Button>
        </div>
      </div>

      <div className="card-body">
        <div className="card-title">Hack Reset limit of Mongen Fusion Pool</div>
        <div className="d-flex w-full">
          <Button
            color="yellow"
            className="btn btn-outline-primary btn-lg"
            onClick={resetFusionMongenLimit}
          >
            Reset limit of Mongen Fusion Pool
          </Button>
        </div>
      </div>

      <div className="card w-full">
        <div className="card-body">
          <div className="card-title">Hack create plot</div>
          <div className="d-flex w-full">
            <div className="flex gap-4">
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setPlotRace(data.value);
                }}
                options={Config.Race.map((value: any, index: number) => {
                  return {
                    text: value,
                    value: index,
                  };
                })}
              />
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setPlotRarity(data.value);
                }}
                options={Config.Rarity.map((value: any, index: number) => {
                  return {
                    text: value,
                    value: index,
                  };
                })}
              />
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setPlotType(data.value);
                  if ([
                    PlotType.Barracks,
                    PlotType.Bombard,
                    PlotType.Tower,
                    PlotType.Trap,
                    PlotType.Camp,
                  ].includes(data.value)) {
                    setSubPlotType(0)
                  } else {
                    setSubPlotType(null)
                  }
                }}
                options={Config.PlotType.map((value: any, index: number) => {
                  return {
                    text: value,
                    value: index,
                  };
                })}
              />
              {[
                PlotType.Barracks,
                PlotType.Bombard,
                PlotType.Tower,
                PlotType.Trap,
                PlotType.Camp,
              ].includes(plot_type) &&
                <Select
                  className="form-control"
                  onChange={(evt: any, data: any) => {
                    setSubPlotType(data.value);
                  }}
                  value={sub_plot_type}
                  options={Object.keys(getSubType(plot_type)).map((value: any, index: number) => {
                    return {
                      text: value,
                      // @ts-ignore
                      value: getSubType(plot_type)[value],
                    };
                  })}
                />
              }
              <Input
                label="amount"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  setAmount(evt.target.value);
                }}
              />
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackCreatePlot}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack create box</div>
          <div className="flex gap-4">
            <Select
              className="form-control"
              onChange={(evt: any, data: any) => {
                setPoolId(data.value);
              }}
              options={pool.map((value: any, index: number) => {
                return {
                  text: value.id,
                  value: value.id,
                };
              })}
            />
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackCreateBox}
            >
              Hack
            </Button>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack create mongens</div>
          <div className="d-flex w-full">
            <div className="flex gap-4">
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setMongenRace(data.value);
                }}
                options={Config.Race.map((value: any, index: number) => {
                  return {
                    text: value,
                    value: index,
                  };
                })}
              />
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setMongenRarity(data.value);
                }}
                options={Config.Rarity.map((value: any, index: number) => {
                  return {
                    text: value,
                    value: index,
                  };
                })}
              />
              {mongen_rarity === Rarity.Legendary && <Enum
                placeholder="Mark"
                enumName="mongen-mark"
                value={mark}
                onChange={(val) => {
                  setMark(Number(val));
                }}
              />}
              <Input
                label="amount1"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  setAmount1(evt.target.value);
                }}
              />
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackCreateEgg}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack dailyquest GOLD MAG</div>
          <div className="d-flex w-full">
            <div className="flex gap-4">
              <Input
                label="amount2"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  setAmount2(evt.target.value);
                }}
              />
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackPlusPoint}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack open PLUS QUEST</div>
          <div className="d-flex w-full">
            <div className="flex gap-4">
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackOpenPlusQuest}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack convert mongen to egg</div>
          <div className="d-flex w-full">
            <div className="row">
              <div className="flex gap-4">
                <Input
                  label="mongen_id"
                  className="form-control"
                  onChange={(evt: any) => {
                    setCVMongenId(evt.target.value);
                  }}
                />
                <Button
                  color="green"
                  className="btn btn-primary btn-lg"
                  onClick={convertMongenToEgg}
                >
                  Hack
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack rune</div>
          <div className="d-flex w-full">
            <div className="row">
              <div className="flex gap-4">
                <Select
                  className="form-control"
                  value={runeCode}
                  onChange={(evt: any, data: any) => {
                    setRuneCode(data.value);
                  }}
                  options={dataServices.getAllRune().map((value: any, index: number) => {
                    return {
                      text: value.code,
                      value: value.code,
                    };
                  })}
                />
                <Select
                  className="form-control"
                  onChange={(evt: any, data: any) => {
                    setRuneRarity(data.value);
                  }}
                  value={runeRarity}
                  options={Config.Rarity.map((value: any, index: number) => {
                    return {
                      text: value,
                      value: index,
                    };
                  })}
                />
                <Input
                  label="Amount"
                  className="form-control"
                  type="number"
                  onChange={(evt: any) => {
                    setRuneAmount(evt.target.value);
                  }}
                />
                <Button
                  color="green"
                  className="btn btn-primary btn-lg"
                  onClick={hackRune}
                >
                  Hack
                </Button>
              </div>
            </div>
          </div>
        </div>

        <div className="card-body">
          <div className="card-title">Hack customer transaction</div>
          <div className="d-flex w-full">
            <div className="flex gap-4">
              <Input
                label="Amount3"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  setAmount3(evt.target.value);
                }}
              />
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setTransactionType(data.value);
                }}
                options={Config.CustomerResources.map((value: any, index: number) => {
                  return {
                    text: value,
                    value: index,
                  };
                })}
              />
              <Button
                color="green"
                className="btn btn-primary btn-lg"
                onClick={hackCustomerTransaction}
              >
                Hack
              </Button>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="card-title">Hack tutorial process</div>
          <div className="d-flex w-full">
            <div className="row">
              <div className="flex gap-4">
                <Input
                  label="Milestone"
                  className="form-control"
                  type="number"
                  onChange={(evt: any) => {
                    setProcess(evt.target.value);
                  }}
                />
                <Button
                  color="green"
                  className="btn btn-primary btn-lg"
                  onClick={hackTutorialProcess}
                >
                  Hack
                </Button>
              </div>
              <div className="mt-3"></div>
            </div>
          </div>
        </div>
        <div className="card-body">
          <div className="card-title">Hack delete customer</div>
          <Button color="red" onClick={hackDeleteCustomer}>
            Delete
          </Button>
        </div>
        <div className="card-body">
          <div className="card-title">Hack claim scholar reward</div>
          <Button color="red" onClick={hackClaimScholarReward}>
            Hack claim scholar
          </Button>
        </div>
        <div className="card-body">
          <div className="card-title">Hack delete name</div>
          <Button color="red" onClick={deleteName}>
            Delete
          </Button>
        </div>
        <div className="card-body">
          <div className="card-title">Hack out battle</div>
          <div className="row">
            <div className="flex gap-4">
              <Input
                label="Wallet Address / Customer Id"
                className="form-control"
                type="text"
                onChange={(evt: any) => {
                  if (typeOutBattle == "0") {
                    setWalletAddressOutBattle(evt.target.value);
                  }
                  if (typeOutBattle == "1") {
                    setCustomerIdOutBattle(evt.target.value);
                  }
                }}
              />
              <Select
                className="form-control"
                onChange={(evt: any, data: any) => {
                  setTypeOutBattle(data.value);
                }}
                options={["Wallet Address", "Customer Id"].map(
                  (value: any, index: number) => {
                    return {
                      text: value,
                      value: index,
                    };
                  }
                )}
              />
              <Button
                color="green"
                className="btn btn-danger btn-lg"
                onClick={outBattle}
              >
                Out Battle
              </Button>
            </div>
            <div className="mt-3"></div>
          </div>
        </div>
      </div>

      <div className="card w-full">
        <div className="card-title">Hack skiptime</div>
        <div className="card-body flex gap-4">
          <Input
            label="plot_id"
            className="form-control"
            type="text"
            onChange={(evt: any) => {
              setPlotIdSkiptime(evt.target.value);
            }}
          />
          <Input
            label="time"
            className="form-control"
            type="number"
            onChange={(evt: any) => {
              setSkiptime(Number(evt.target.value));
            }}
          />
          <Button
            color="green"
            className="btn btn-primary btn-lg"
            onClick={hackSkiptime}
          >
            Hack
          </Button>
        </div>
      </div>

      <div className="card w-full">
        <div className="card-body">
          <div className="card-title">Hack create troops</div>
          <div className="flex gap-4">
            <Select
              className="form-control"
              onChange={(evt: any, data: any) => {
                setTroopId(data.value);
              }}
              options={troops?.map((value: any, index: number) => {
                return {
                  value: index,
                  text: value.name,
                };
              })}
            />
            <Input
              label="mongen_id"
              className="form-control"
              type="number"
              onChange={(evt: any) => {
                setMongenId(Number(evt.target.value));
              }}
            />
            <Input
              label="quantity"
              className="form-control"
              type="number"
              onChange={(evt: any) => {
                setQuantity(Number(evt.target.value));
              }}
            />
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackCreateTroops}
            >
              Hack
            </Button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="card-title">Hack update troops</div>
          <div className="grid grid-rows-4 gap-4">
            <Input
              label="mongen_id"
              className="form-control w-[200px]"
              type="number"
              onChange={async (evt: any) => {
                setMongenId(Number(evt.target.value));
                await api
                  .getMongenInfo(Number(evt.target.value))
                  .then((res: { mongenInfo: (prevState: undefined) => undefined }) => {
                    setMongenInfo(res.mongenInfo);
                  })
                  .catch((err: any) => { });
              }}
            />
            {[0, 1, 2].map((index) => {
              return (
                <div className="flex gap-4" key={index}>
                  <Input
                    label="troop_id"
                    className="form-control"
                    type="number"
                    value={
                      mongenInfo && mongenInfo.U && mongenInfo.U[index]
                        ? mongenInfo.U[index].id
                        : ""
                    }
                    onChange={(evt: any) => {
                      const newMongenInfo = JSON.parse(JSON.stringify(mongenInfo));
                      newMongenInfo.U[index].id = Number(evt.target.value);
                      setMongenInfo(newMongenInfo);
                    }}
                  />
                  <Input
                    label="quantity"
                    className="form-control"
                    type="number"
                    value={
                      mongenInfo && mongenInfo.U && mongenInfo.U[index]
                        ? mongenInfo.U[index].quant
                        : ""
                    }
                    onChange={(evt: any) => {
                      const newMongenInfo = JSON.parse(JSON.stringify(mongenInfo));
                      newMongenInfo.U[index].quant = Number(evt.target.value);
                      setMongenInfo(newMongenInfo);
                    }}
                  />
                </div>
              );
            })}
            <Button
              color="green"
              className="w-[200px]"
              onClick={hackUpdateTroopMongen}
            >
              Hack
            </Button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <div className="card-title">Hack update date battlefront</div>
          <div className="flex gap-4 items-center gap-4">
            <Input
              label="Customer ID"
              className="form-control"
              type="number"
              onChange={(evt: any) => {
                setBattleCustomerId(Number(evt.target.value));
              }}
            />
            <div className="w-[300px]">
              <DatePicker
                placeholderText={"date"}
                isClearable
                locale="es"
                selected={battlefrontCustomerDate}
                onChange={(val: Date) => {
                  if (!val) {
                    setBattlefrontCustomerDate(null);
                  } else {
                    console.log(dayjs(val).toDate());
                    setBattlefrontCustomerDate(
                      dayjs(val).startOf("day").add(7, "hour").toDate()
                    );
                  }
                }}
                dateFormat="yyyy/MM/dd HH:mm"
                className="border p-2 rounded ml-4 w-[280px]"
              />
            </div>
            <Button color="green" className="w-[200px]" onClick={hackDateBattlefront}>
              Hack
            </Button>
          </div>
        </div>
      </div>

      <div className="card w-full">
        <div className="card-body">
          <div className="card-title">Hack update skill</div>
          <div className="flex gap-4">
            <Input
              label="mongen_id"
              className="form-control"
              type="number"
              onChange={async (evt: any) => {
                setMongenId(Number(evt.target.value));
                await api
                  .getMongenInfo(Number(evt.target.value))
                  .then((res: { mongenInfo: (prevState: undefined) => undefined }) => {
                    setMongenInfo(res.mongenInfo);
                  })
                  .catch((err: any) => { });
              }}
            />
            <Select
              className="form-control"
              onChange={(evt: any, data: any) => {
                setTypeSkill(data.value);
              }}
              options={[
                {
                  text: "Basic skill",
                  value: "basic",
                },
                {
                  text: "Ultimate skill",
                  value: "ultimate",
                },
              ]}
            />
            <Input
              label="skill"
              className="form-control"
              type="text"
              value={
                typeSkill === "basic" && mongenInfo && mongenInfo.R
                  ? mongenInfo.R.join(",")
                  : typeSkill === "ultimate" && mongenInfo && mongenInfo.S
                    ? mongenInfo.S.join(",")
                    : ""
              }
              onChange={(evt: any) => {
                const newMongenInfo = JSON.parse(JSON.stringify(mongenInfo));
                if (typeSkill === "basic")
                  newMongenInfo.R = evt.target.value.split(",");
                if (typeSkill === "ultimate")
                  newMongenInfo.S = evt.target.value.split(",");
                setMongenInfo(newMongenInfo);
              }}
            />
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackUpdateSkillMongen}
            >
              Hack
            </Button>
          </div>
        </div>
      </div>

      <div className="card w-full">
        <div className="card-body">
          <div className="card-title">Hack update curse</div>
          <div className="flex gap-4">
            <Input
              label="curse_level"
              className="form-control"
              type="number"
              min={-10}
              max={5}
              step={1}
              onChange={async (evt: any) => {
                setCurseLevel(Number(evt.target.value));
              }}
            />
            <Select
              className="form-control"
              onChange={(evt: any, data: any) => {
                setCurseCode(data.value);
              }}
              options={[
                { text: 'customer_farm_amount', value: 'customer_farm_amount' },
                { text: 'customer_farm_time', value: 'customer_farm_time' },
                { text: 'customer_food_cap', value: 'customer_food_cap' },
                {
                  text: 'customer_training_food_cost',
                  value: 'customer_training_food_cost'
                },
                { text: 'customer_training_time', value: 'customer_training_time' },
                {
                  text: 'customer_HP_all_landplot',
                  value: 'customer_HP_all_landplot'
                },
                { text: 'customer_HP_all_mongen', value: 'customer_HP_all_mongen' },
                { text: 'customer_STD_all_all', value: 'customer_STD_all_all' },
                { text: 'customer_MG_all_all', value: 'customer_MG_all_all' },
                { text: 'customer_AGR_all_all', value: 'customer_AGR_all_all' },
                { text: 'customer_hatching_time', value: 'customer_hatching_time' },
                { text: 'customer_breeding_time', value: 'customer_breeding_time' },
                {
                  text: 'customer_plot_upgrade_time',
                  value: 'customer_plot_upgrade_time'
                }
              ]}
            />
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackUpdateCurse}
            >
              Hack
            </Button>
          </div>
        </div>
      </div>

      <div className="card w-full">
        <div className="card-body">
          <div className="card-title">Hack update morale stats</div>
          <div className="grid grid-cols-4 gap-4 mb-4">
            <div>battle_count: {mongenInfo?.["AA"] ?? 0}</div>
            <div>acc_battle: {mongenInfo?.["AB"] ?? 0}</div>
            <div>win_count: {mongenInfo?.["AC"] ?? 0}</div>
            <div>lose_count: {mongenInfo?.["AD"] ?? 0}</div>
            <div>fed_food: {mongenInfo?.["AE"] ?? 0}</div>
            <div>fed_evolve: {mongenInfo?.["AF"] ?? 0}</div>
            <div>fed_stones: {mongenInfo?.["AG"] ?? 0}</div>
            <div>loyalty: {mongenInfo?.["AH"] ?? 0}</div>
            <div>morale: {mongenInfo?.["AI"] && MongenMorale[mongenInfo["AI"]]}</div>
            <div>morale_eff_value: {mongenInfo?.["AJ"] ?? 0}</div>
            <div className="col-span-2">
              refresh_mongen_moral:{" "}
              {mongenInfo?.["AK"] &&
                `${new Date(mongenInfo?.["AK"]).toDateString()} ${new Date(
                  mongenInfo?.["AK"]
                ).toLocaleTimeString()}`}
            </div>
          </div>
          <div className="flex gap-4">
            <Input
              label="mongen_id"
              className="form-control"
              type="number"
              onChange={async (evt: any) => {
                setMongenId(Number(evt.target.value));
                await api
                  .getMongenInfo(Number(evt.target.value))
                  .then((res: { mongenInfo: (prevState: undefined) => undefined }) => {
                    setMongenInfo(res.mongenInfo);
                  })
                  .catch((err: any) => { });
              }}
            />
            <Select
              className="form-control"
              onChange={(evt: any, data: any) => {
                setMoraleType(data.value);
              }}
              options={[
                {
                  text: "Loyalty",
                  value: "loyalty",
                },
                {
                  text: "Fed food",
                  value: "fed_food",
                },
                {
                  text: "Fed evolve",
                  value: "fed_evolve",
                },
                {
                  text: "Fed stones",
                  value: "fed_stones",
                },
                {
                  text: "Lose count",
                  value: "lose_count",
                },
                {
                  text: "Win count",
                  value: "win_count",
                },
                {
                  text: "Battle count",
                  value: "battle_count",
                },
                {
                  text: "Refresh mongen time",
                  value: "refresh_mongen_morale",
                },
              ]}
            />
            {moraleType === "refresh_mongen_morale" && (
              <Input
                type="datetime-local"
                onChange={(e) => {
                  setMoraleValue(e.target.value);
                }}
              />
            )}
            {moraleType && moraleType !== "refresh_mongen_morale" && (
              <Input
                type="number"
                onChange={(e) => {
                  setMoraleValue(e.target.value);
                }}
              />
            )}
            <Button
              color="green"
              className="btn btn-primary btn-lg"
              onClick={hackUpdateMoraleMongen}
            >
              Hack Increase stats
            </Button>
            <Button
              color="yellow"
              className="btn btn-secondary btn-lg"
              onClick={randomMorale}
            >
              Hack Random Morale
            </Button>
          </div>
        </div>
      </div>

      <div className=" w-full mt-10 mb-10">
        <h3>Encrypt</h3>
        <div className="card w-full">
          <div className="card-body">
            <TextArea
              className="w-full"
              style={{ border: "1px solid black" }}
              label="input"
              rows={6}
              type="text"
              value={inputData}
              onChange={(e) => setInputData(e.target.value)}
            />
          </div>
          <div className="card-body">
            <Button
              color="blue"
              className="btn btn-primary btn-lg"
              onClick={encryptInput}
            >
              Encrypt
            </Button>
            <Button
              color="green"
              className="btn btn-primary btn-lg m-3"
              onClick={decryptInput}
            >
              Decrypt
            </Button>
            <Button
              color="blue"
              className="btn btn-primary btn-lg"
              onClick={newEncryptInput}
            >
              New Encrypt
            </Button>
            <Button
              color="green"
              className="btn btn-primary btn-lg m-3"
              onClick={newDecryptInput}
            >
              New Decrypt
            </Button>
          </div>
          <div className="flex gap-4 mt-10">
            <div>Output</div>
            <div
              className="cursor-pointer"
              onClick={() => {
                navigator.clipboard.writeText(outputData);
                setCopied(true);
                setTimeout(() => {
                  setCopied(false);
                }, 2000);
              }}
            >
              <Icon name={isCopied ? "check" : "copy"} size="small" />
            </div>
          </div>
          <div
            className="w-full h-24 mt-2"
            style={{
              border: "1px solid black",
            }}
          >
            <code className="mx-auto">{outputData}</code>
          </div>
        </div>
      </div>
    </div>
  );
}